<div class="card-footer" *ngIf="resultsVisible()"> <!-- TODO: Remove function call from template -->
  <ul class="pagination d-flex justify-content-center m-1 align-items-center">
    <li class="page-item">
      <a class="page-link" (click)="getPreviousRecords()" [ngClass]="{'disabled': pagerService.listStart === 0 }"><span
          aria-hidden="true">&laquo;</span></a>
    </li>
    <li class="page-item" *ngIf="pagerService.listNext !== pagerService.matchedRecords">
      <span class="page-link">
        {{'COMMON.results' | translateHs }}
        {{pagerService.listStart + 1}} -
        {{pagerService.listNext}}</span>
    </li>
    <li class="page-item" *ngIf="pagerService.listNext === pagerService.matchedRecords">
      <span class="page-link">
        {{'COMMON.results' | translateHs }}
        {{pagerService.listStart + 1}} -
        {{pagerService.matchedRecords}}</span>
    </li>
    <li class="page-item">
      <!-- TODO: Remove function call from template -->
      <a class="page-link" data-cy="hs-pager-next-page" (click)="getNextRecords()"
        [ngClass]="{'disabled': nextPageAvailable() }"><span aria-hidden="true">&raquo;</span></a>
    </li>
    <li ngbDropdown display="dynamic" placement="top-right" class="pe-3" style="position: absolute;
    right: 0;">
      <div class="btn-group">
        <button class="but-title-sm m-1" data-toggle="tooltip"
          [title]="'ADDDATA.CATALOGUE.theNumberOfRecords' | translateHs ">
          <i class="icon-question-sign"></i>
        </button>
        <button ngbDropdownToggle type="button" data-cy="hs-pager-menu-toggle"
          class="btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split rounded-0"
          [title]="'COMMON.selectRecordCountPerPage' | translateHs " aria-haspopup="true" aria-expanded="false">
        </button>
      </div>
      <div ngbDropdownMenu class="dropdown-menu">
        <a class="dropdown-item" *ngFor="let perPage of recordsPerPageArray"
          (click)="changeRecordsPerPage(perPage)">{{perPage}}</a>
      </div>
    </li>
  </ul>
</div>
